import React from 'react';
import './TwoStep.css';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const steps = [
  {
    moves: `
      <b>Right foot back</b><br>
      <b>i. </b>Left <span class="blue">Walking Stance</span>, left inner forearm middle block.<br>
      <b>ii. </b>Right <span class="blue">Walking Stance</span>, right inner forearm middle block.<br>
      <b>iii. </b>Left <span class="blue">Walking Stance</span>, left inner forearm middle block.<br><br>
      <b>Maintaining a left <span class="blue">Walking Stance</span>, right middle reverse punch.</b>
    `
  },
  {
    moves: `
      <b>Left foot back</b><br>
      <b>i. </b>Right <span class="blue">Walking Stance</span>, right inner forearm middle block.<br>
      <b>ii. </b>Left <span class="blue">Walking Stance</span>, left inner forearm middle block.<br>
      <b>iii. </b>Right <span class="blue">Walking Stance</span>, right inner forearm middle block.<br><br>
      <b>Move the left leg to the left diagonal forming a <span class="blue">Sitting Stance</span>, left middle punch to floating ribs.</b>
    `
  },
  {
    moves: `
      <b>Left foot back</b><br>
      <b>i. </b>Left <span class="blue">L-Stance</span>, right knife-hand middle block.<br>
      <b>ii. </b>Right <span class="blue">L-Stance</span>, left knife-hand middle block.<br>
      <b>iii. </b>Left <span class="blue">L-Stance</span>, right knife-hand middle block.<br><br>
      <b>Slip the right foot into a right <span class="blue">Fixed Stance</span>, right knife-hand strike to floating ribs.</b>
    `
  },
  {
    moves: `
      <b>Left foot back</b><br>
      <b>i. </b>Left leg moves back into <span class="blue">Sitting Stance</span>, right outer forearm middle block.<br>
      <b>ii. </b>Right leg moves back into <span class="blue">Sitting Stance</span>, left outer forearm middle block.<br>
      <b>iii. </b>Left leg moves back into <span class="blue">Sitting Stance</span>, right outer forearm middle block.<br><br>
      <b>Slide forward into right <span class="blue">L-Stance</span>, right side-elbow strike to solar plexus.</b>
    `
  },
  {
    moves: `
      <b>Right foot back</b><br>
      <b>i. </b>Right <span class="blue">L-Stance</span>, knife-hand guarding block.<br>
      <b>ii. </b>Left <span class="blue">L-Stance</span>, knife-hand guarding block.<br><br>
      <b>Move the right leg out at 45 degrees forming a left <span class="blue">Walking Stance</span> while executing right knife-hand inward strike to the neck performed simultaneously with a left knife-hand middle block.</b>
    `
  },
  {
    moves: `
      <b>Right foot back</b><br>
      <b>i. </b>Right <span class="blue">L-Stance</span>, knife-hand guarding block.<br>
      <b>ii. </b>Left <span class="blue">L-Stance</span>, knife-hand guarding block.<br>
      <b>iii. </b>Slide to the right diagonal at 45 degrees; to provide distance to form the correct kick, forming a right <span class="blue">L-Stance</span>, knife-hand guarding block.<br><br>
      <b>Front snap kick to the groin followed by a right <span class="blue">Walking Stance</span> while executing right knife-hand inward strike to the neck performed simultaneously with a left knife-hand middle block.</b>
    `
  },
  {
    moves: `
      <b>Right foot back</b><br>
      <b>i. </b>Right <span class="blue">L-Stance</span>, knife-hand guarding block.<br>
      <b>ii. </b>Left <span class="blue">L-Stance</span>, knife-hand guarding block.<br>
      <b>iii. </b>Slide to the right diagonal at 45 degrees; to provide distance to form the correct kick, forming a right <span class="blue">L-Stance</span>, knife-hand guarding block.<br><br>
      <b>Right middle side kick followed by a right knife-hand strike to the neck in a left <span class="blue">L-Stance</span>.</b>
    `
  },
  {
    moves: `
      <b>Right foot back</b><br>
      <b>i. </b>Right <span class="blue">L-Stance</span>, knife-hand guarding block.<br>
      <b>ii. </b>Left <span class="blue">L-Stance</span>, knife-hand guarding block.<br>
      <b>iii. </b>Slide to the right diagonal at 45 degrees; to provide distance to form the correct kick, forming a left <span class="blue">L-Stance</span>, knife-hand guarding block.<br><br>
      <b>Left middle side kick followed by a left knife-hand strike to the neck in a right <span class="blue">L-Stance</span>.</b>
    `
  },
  {
    moves: `
      <b>Right foot back</b><br>
      <b>i. </b>Right <span class="blue">L-Stance</span>, knife-hand guarding block.<br>
      <b>ii. </b>Left <span class="blue">L-Stance</span>, knife-hand guarding block.<br>
      <b>iii. </b>Pivot clockwise on left foot to an angle of 45 degrees; to provide distance to form the correct kick, and slide into a right <span class="blue">L-Stance</span>, knife-hand guarding block.<br><br>
      <b>Right turning kick at a 45° angle to the solar plexus followed by a right back fist strike to the temple in a left <span class="blue">L-Stance</span>.</b>
    `
  }
];

const ThreeStep = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>TKD Study - 3 Step</title>
      </Helmet>

      <div className="three-step-container">
        <h1 className="three-step-title">Three Step</h1>
        <button className="back-button" onClick={() => navigate(-1)}>← Back</button>

        <div className="three-step-content">
          <p>
            <b>What is Three Step?</b><br />
            Three step <span className="green"><b>(Sambo Matsogi)</b></span> is an exercise for familiarization of correct attack and defense techniques utilizing mainly the hand parts against middle and high targets and the foot parts against low targets while stepping forward and backwards.
          </p>

          <p>
            <b><big>Attacking</big></b><br />
            The attack in 3 step always starts from a left <span className="blue"><b>Walking Stance</b></span> while executing a low block with the left forearm.<br /><br />
            <b>Attack</b><br />
            <b>i. </b>On commencement the attacker moves forward into a right <span className="blue"><b>Walking Stance</b></span> while executing a front punch with their right fist.<br />
            <b>ii. </b>Next the attacker moves forward into a left <span className="blue"><b>Walking Stance</b></span> while executing a front punch with their left fist.<br />
            <b>iii. </b>The last attack is the same as <b>i</b>, moving forward, right <span className="blue"><b>Walking Stance</b></span> executing right punch.
          </p>

          <p>
            <b><big>Defending</big></b><br />
            The defence in 3 step always starts from <span className="blue"><b>Parallel Ready Stance</b></span>.<br />
            Throughout the 9 routines, the defence techniques differ.<br />
            Each defence ends with a <b>counter-attack</b>.
          </p>

          {steps.map((step, idx) => (
            <div className="three-step-section" key={idx}>
              <div className="step-moves">
                <h2 className="step-title">No. {idx + 1}</h2>
                <div dangerouslySetInnerHTML={{ __html: step.moves }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ThreeStep;